<template>
    <div id="app">
      <router-view name="header"></router-view>
      <main>
        <fade-transition origin="center" mode="out-in" :duration="250">
          <router-view/>
        </fade-transition>
      </main>
      <router-view name="footer"></router-view>

    </div>

</template>
<script>
import { FadeTransition } from "vue2-transitions";
import axios from 'axios';

export default {
  components: {
    FadeTransition
  },
  data() {
    return {
      isLoading: true,
      selectedVoice: 1,
      synth: window.speechSynthesis,
      textToSpeak: "",
      voiceList: [],
      greetingSpeech: new window.SpeechSynthesisUtterance() };

  },
  methods: {
    handleWordSelection(event) {
      const selectedText = window.getSelection().toString();
      if (selectedText && (this.$i18n.locale === 'uz-UZ'||this.$i18n.locale === 'uz-CYR') ) {
        this.textToSpeak = selectedText;
        this.convertAndPlay();
      }
      if (selectedText && (this.$i18n.locale === 'en-US') ) {
        this.selectedVoice = 5;
        const selectedWord = selectedText.trim().split(' ');
         // console.log(this.greetingSpeech);
        this.greetingSpeech.text = selectedWord;
        this.greetingSpeech.voice = this.voiceList[this.selectedVoice];
        // this.synth.speak(this.greetingSpeech);
        window.speechSynthesis.speak(this.greetingSpeech);

      } else if (selectedText && (this.$i18n.locale === 'ru-RU') ) {
        this.selectedVoice = 1;
        const selectedWord = selectedText.trim().split(' ');
        // console.log(this.greetingSpeech);
        this.greetingSpeech.text = selectedWord;
        this.greetingSpeech.voice = this.voiceList[this.selectedVoice];
        // this.synth.speak(this.greetingSpeech);
        window.speechSynthesis.speak(this.greetingSpeech);
      }
    },
    async convertAndPlay() {
      try {
        const speakerId = 1;
        const apiUrl = `https://api.muxlisa.uz/v1/tts/tts-ogg/?speaker_id=${speakerId}&text=`+this.textToSpeak;

        const response = await axios.get(apiUrl, {
          responseType: 'blob',
        });
        const audioBlob = new Blob([response.data], { type: 'audio/ogg' });
        const audioUrl = URL.createObjectURL(audioBlob);

        const audio = new Audio(audioUrl);
        audio.play();
      } catch (error) {
        // console.log('Xatolik', error);
        console.log('Til', this.$i18n.locale);
      }
    },
  },
  mounted() {
    window.addEventListener('mouseup', this.handleWordSelection);
    this.voiceList = this.synth.getVoices();
    if (this.voiceList.length) {
      this.isLoading = false;
    }
    this.synth.onvoiceschanged = () => {
      this.voiceList = this.synth.getVoices();
      setTimeout(() => {
        this.isLoading = false;
      }, 800);
    };

    this.handleWordSelection();
  },
  beforeDestroy() {
    window.removeEventListener('mouseup', this.handleWordSelection);
  },
};
</script>

<style scoped>

</style>
